module.exports = __webpack_public_path__ + "img/logo_login.b9f55f42.svg";